import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import Appbar from "../../Component/NavPannel/Appbar";
import CustodiansRoutes from "../../Component/Layouts/CustodiansLayout";

const mdTheme = createTheme();

function CustodiansMain() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex", height: "100vh" }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Custodians Management" />
        <CustodiansRoutes />
      </Box>
    </ThemeProvider>
  );
}

export default function Custodians() {
  return <CustodiansMain />;
}
